// extracted by mini-css-extract-plugin
export var active = "_gh-7";
export var blink = "_gh-8";
export var dropDownSelector = "_gh-4";
export var dropDownWrapper = "_gh-3";
export var fakeCursor = "_gh-6";
export var fontSizeButton = "_gh-9";
export var formQuillEditor = "_gh-0";
export var pressed = "_gh-a";
export var qlBlank = "_gh-1";
export var textFormattingToolbar = "_gh-2";
export var textToolbarOption = "_gh-5";